<app-header></app-header>
<ion-content>
  <ion-grid class="subHeader">
    <ion-row class="ion-justify-content-around ion-align-items-center">
      <ion-col size="6">
        <ion-toolbar mode="md">
          <ion-buttons slot="start">
            <ion-back-button defaultHref="/home"></ion-back-button>
          </ion-buttons>
          <ion-title class="page-title" slot="start">{{'imSelling'|language:'I am Selling'}}</ion-title>
        </ion-toolbar>
      </ion-col>
      <ion-col size="6">
        <ion-searchbar [debounce]="500" search-icon="search-outline" id="myInput" mode="md" show-clear-button="focus"
          placeholder="{{'search'|language:'Search'}}" #search></ion-searchbar>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-grid class="modal-grid" *ngIf="!isLoading">
    <ion-segment mode="ios" [(ngModel)]="selectedtab" [value]="selectedtab">
      <ion-segment-button class="ion-text-capitalize" [disabled]="disableProduct" value="product"
        (click)="isSellingService(false)">
        <ion-label>{{'Products' | language : 'Products'}}</ion-label>
      </ion-segment-button>
      <ion-segment-button class="ion-text-capitalize" [disabled]="disableService" value="service"
        (click)="isSellingService(true)">
        <ion-label>{{'Services' | language : 'Services'}}</ion-label>
      </ion-segment-button>
    </ion-segment>
    <ion-row *ngIf="masterCategoryArray?.length">
      <ng-container *ngFor="let category of getCategoriesData();">
        <ion-col size="6" size-sm="4" size-md="4" size-lg="4"
          *ngIf="search.value ? category.name.toLowerCase().includes(search.value.toLowerCase()) : true">
          <ion-card class="ion-card-modal" mode="ios">
            <span>
              <ion-checkbox class="custom-checkbox" id="{{category?.name}}" (click)="chooseCategory(category)"
                [(ngModel)]="category.checked" [disabled]="categoryPresentinBackend.includes(category.name)"
                mode="md"></ion-checkbox>
            </span>
            <div class="categories-list"
              (click)="categoryPresentinBackend.includes(category.name) ? '' : category.checked = !category.checked;chooseCategory(category)">
              <ion-img class="productimage" [src]="category?.image"></ion-img>
              <ion-card-header>
                <ion-card-title>{{category?.id | language: category?.name}}</ion-card-title>
              </ion-card-header>
            </div>
          </ion-card>
        </ion-col>
      </ng-container>
    </ion-row>
    <app-footer></app-footer>
  </ion-grid>
</ion-content>
<ion-footer mode="ios">
  <ion-button expand="block" shape="round" (click)="navigate()">
    {{'continue' | language : 'Continue'}}
  </ion-button>
</ion-footer>